import React from 'react';

export const ScrollArea = ({ children, className, ...props }) => {
  return (
    <div
      className={`scroll-area bg-gris-pizarra text-blanco-nieve overflow-auto rounded-md ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
